import { common } from "@mui/material/colors";
import { PaletteOptions, alpha } from "@mui/material/styles";
import { error, indigo, info, neutral, success, warning } from "./colors";

interface ICreatePalette extends PaletteOptions {
  neutral: { [key: number]: string };
}
export function createPalette(): ICreatePalette {
  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: common.white,
      paper: common.white,
    },
    divider: "#F2F4F7",
    error,
    info,
    mode: "light",
    neutral,
    primary: indigo,
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
    warning,
  };
}
